// extracted by mini-css-extract-plugin
module.exports = {"header":"tableColumnHeader_header__3xE4b","unsorted":"tableColumnHeader_unsorted__3zEXO"};